///	<reference path="./tsb.d.ts"/>

import Cache from './cache'
import Config from '../common/config'
import axios, { AxiosRequestConfig } from 'axios'
import { MessageBox } from 'element-ui'

export default class Request
{
	private $cache:Cache
	///	响应格式1
	private responseType:AxiosRequestConfig["responseType"] = 'json'
	///	请求类型
	private requestType:string = 'application/json'//'application/x-www-form-urlencoded'
	///	超时时间
	private timeout:number = 30000
	///	token
	private token:string | boolean | JSON = ''
	///	响应体
	private $request:any

	constructor( opt:options = {} )
	{
		this.$cache = new Cache( Config.prefix )
		this.token = localStorage.getItem( 'newToken' )
    console.log("ssssssssssss1", this.token)
		this.timeout = opt.timeout ? opt.timeout : this.timeout
	}

	get( host:string, url:string, params:JSON | FormData )
	{
		this.responseType = 'json'
		const config:opt =
		{
			method : 'get',
			url : url
		}

		if( params )
			config.params = params
		const r = this.init( host )
		return r( config )
	}

	post( host:string, url:string, params:JSON | FormData )
	{
		this.responseType = 'json'
		const config:opt =
		{
			method : 'post',
			url : url,
		}
		if( params )
			config.data = params

		const r = this.init( host )
		return r( config )
	}

	put( host:string, url:string, params:JSON | FormData )
	{
		this.responseType = 'json'
		const config:opt =
		{
			method : 'put',
			url : url
		}
		if( params )
			config.params = params

		const r = this.init( host )
		return r( config )
	}

	delete( host:string, url:string, params:JSON | FormData )
	{
		this.responseType = 'json'
		const config:opt = {
			method : 'delete',
			url : url
		}
		if( params )
			config.params = params

		const r = this.init( host )
		return r( config )
	}

	upload( host:string, url:string, params:JSON | FormData )
	{
		this.responseType = 'json'
		const config:opt =
		{
			method : 'post',
			url : url
		}
		if( params )
			config.data = params

		const r = this.init( host )
		return r( config )
	}

	download( host:string, url:string, params:JSON | FormData )
	{
		this.requestType = 'arraybuffer'
		const config:opt =
		{
			method : 'get',
			url : url
		}

		if( params )
			config.params = params

		const r = this.init( host )
		return r( config )
	}

	private init( $api:string )
	{
		this.$request = axios.create({
			baseURL : $api,
			timeout : this.timeout,
			responseType : this.responseType
		})

		///	请求拦截器
		this.$request.interceptors.request.use(
			options =>
			{
				// 每次请求前更新token（从localStorage重新获取）
				this.token = localStorage.getItem( 'newToken' )
				// 如果token不存在，清除登录状态
				if (!this.token) {
					localStorage.removeItem('userInfo')
					window.dispatchEvent(new StorageEvent('storage', {
						key: 'newToken',
						newValue: null,
						oldValue: null
					}))
				}
				
        if( options.url === '/member/resetpassword.php'){
          ///	配置请求头
          options.headers = {
            'Content-Type' : this.requestType,
          }
        }else{
          options.headers = {
            'Content-Type' : this.requestType,
            'token' : `${this.token || ''}`
          }
        }

				///	添加全局参数 global_dwid
				if( options.method === 'get' || options.method === 'delete' )
				{
					// GET 和 DELETE 请求添加到 params
					if( !options.params )
					{
						options.params = {}
					}
					options.params.global_dwid = 68392
				}
				else
				{
					// POST、PUT 等请求添加到 data
					if( options.data )
					{
						if( options.data instanceof FormData )
						{
							// FormData 类型
							options.data.append( 'global_dwid', '68392' )
						}
						else if( typeof options.data === 'object' )
						{
							// 普通对象类型
							options.data.global_dwid = 68392
						}
					}
					else
					{
						options.data = { global_dwid: 68392 }
					}
				}

				return options
			},

			error =>
			{
				Promise.reject( error )
			}
		)

		///	响应拦截器
		this.$request.interceptors.response.use(
			response =>
			{
				return response.data
			},

			error =>
			{
				console.log( error )
				///	接收到异常响应的处理开始
				if( error && error.response )
				{
					///	公共错误处理 / 根据响应码具体处理
					switch( error.response.status )
					{
						case 400:
							error.message = '错误请求'
						break;

					case 401:
						error.message = '未授权，请重新登录'
						// 清除登录状态
						localStorage.removeItem('newToken')
						localStorage.removeItem('userInfo')
						// 触发storage事件，通知Header组件清除登录状态
						window.dispatchEvent(new StorageEvent('storage', {
							key: 'newToken',
							newValue: null,
							oldValue: localStorage.getItem('newToken')
						}))
					break;

						case 403:
							error.message = '拒绝访问'
						break;

						case 404:
							error.message = '请求错误，未找到该资源'
						break;

						case 405:
							error.message = '请求方法未允许'
						break;

						case 408:
							error.message = '请求超时'
						break;

						case 500:
							error.message = '服务器端出错'
						break;

						case 501:
							error.message = '系统未登录'
							setTimeout(()=>{
								window.location.href='/v8/danwei/#/login'
							},1000)
							
						break;

						case 502:
							error.message = '网络错误'
						break;

						case 503:
							error.message = '服务不可用'
						break;

						case 504:
							error.message = '网络超时'
						break;

						case 505:
							error.message = 'http版本不支持该请求'
						break;

						default:
							error.message = `连接错误${error.response.status}`
					}
				}
				else
				{
					///	超时处理
					if( JSON.stringify( error ).includes( 'timeout' ) )
					{
						MessageBox.alert( '服务器响应超时，请重新尝试', '错误', {
							confirmButtonText: '确定',
							callback : _ => {
								console.log( 'retry' )
							}
						} )
					}

					else MessageBox.alert( '服务器响应超时，请重新尝试', '错误', {
						confirmButtonText: '确定',
						callback : _ => {
							console.log( 'retry' )
						}
					} )
					//error.message( '连接服务器失败' )
				}

				MessageBox.alert( error.message, '错误', {
					confirmButtonText: '确定',
					callback : _ => {
						console.log( 'retry' )
					}
				} )

				return Promise.resolve( error.response )
		})
		return this.$request
	}
}



// WEBPACK FOOTER //
// ./src/lib/request.ts